module.exports = __webpack_public_path__ + "static/media/like-active.c7622ee6.svg";